module.exports = __webpack_public_path__ + "img/calendar-clock.0ba6caf.svg";